<!-- Footer Start -->
<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-8">
                <script>document.write(new Date().getFullYear())</script> &copy; {{anio}} Diseñado y Desarrollado por <br><b>DIRECCIÓN NACIONAL DE TECNOLOGÍAS DE LA INFORMACIÓN Y COMUNICACIÓN </b>
            </div>
            <div class="col-md-4">
                <div class="text-md-end footer-links d-none d-sm-block">
                    <a href="javascript:void(0);"><i class="mdi mdi-information-outline"></i> Acerca de</a>
                    <a href="javascript:void(0);"><i class="mdi mdi-help-circle-outline"></i> Ayuda</a>
                    <a href="javascript:void(0);"><i class="mdi mdi-cellphone-android"></i> Contáctanos</a>
                </div>
            </div>
        </div>
    </div>
</footer>
<!-- end Footer -->